<header class="h-[68px] flex justify-center items-center bg-primary px-10">
  <ftc-icon-svg [icon]="'logo'" [height]="36" class="mx-auto cursor-pointer" [routerLink]="['']"></ftc-icon-svg>
</header>